import React from 'react';
import { Sentry } from '../lib/sentry';

interface SentryWrapperProps {
  children: React.ReactNode;
}

// Only wrap with Sentry components when VITE_DEBUG is "false" (production mode)
const SentryWrapper: React.FC<SentryWrapperProps> = ({ children }) => {
  if (import.meta.env.VITE_DEBUG === "false") {
    return (
      <Sentry.ErrorBoundary
        fallback={({ error, componentStack }) => {
          // Log the error to Sentry but don't show any UI
          console.error('React Error Boundary caught an error:', error, componentStack);
          return null; // Return null to not render anything
        }}
        onError={(error, componentStack) => {
          // This will be called when an error is caught, but we don't show any UI
          console.error('React Error Boundary onError:', error, componentStack);
        }}
      >
        {children}
      </Sentry.ErrorBoundary>
    );
  }

  // In development, just return children without Sentry wrapper
  return <>{children}</>;
};

export default SentryWrapper; 